import "./spf.scss";
const SPFShopLayout = ({ children }) => {
  return <div className="container-main container-spf">{children}</div>;
};

export default SPFShopLayout;
